import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/lib/data";

export default function BlogTeaser() {
  return (
    <section data-testid="blog-teaser-section" className="bg-mrn-bg py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-mrn-terracotta font-medium">
              Journal
            </p>
            <h2 className="mt-4 headline-display text-4xl md:text-6xl text-mrn-wood">
              Travel guides <em className="font-light text-mrn-green">&amp; notes.</em>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-see-all"
            className="mrn-pill mrn-pill-outline"
          >
            All guides <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {BLOG_POSTS.slice(0, 3).map((p, i) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.slug}
              data-testid={`blog-card-${i}`}
              className="group"
            >
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={p.cover}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="pt-5">
                <div className="text-xs uppercase tracking-widest text-mrn-terracotta">
                  {p.date} · {p.readTime}
                </div>
                <h3 className="mt-3 font-display text-2xl text-mrn-wood leading-snug">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-mrn-wood-soft line-clamp-2">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
